/* global axios */

class SuppliersAPI {
  get(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/suppliers`);
  }

  create(accountId, payload) {
    return axios.post(`/api/v1/accounts/${accountId}/suppliers`, {
      supplier: payload,
    });
  }

  update(accountId, id, payload) {
    return axios.patch(`/api/v1/accounts/${accountId}/suppliers/${id}`, {
      supplier: payload,
    });
  }

  delete(accountId, id) {
    return axios.delete(`/api/v1/accounts/${accountId}/suppliers/${id}`);
  }
}

export default new SuppliersAPI();
